var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('van-loading',{staticClass:"loading-content",attrs:{"type":"spinner","size":"30px","color":"#ffffff","vertical":""}},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }